"use client";

import Link from "next/link";
import Image from "next/image";
import { useParams } from "next/navigation";
import { ChevronLeft } from "lucide-react";
import { useEventDetailStore } from "@/stores/eventDetailStore";
import { cn } from "@/lib/utils";

// Mobile-only event identity + back link. Replaces the old MobileTopBar: the
// bar's ⋯ button opened the same sheet as the bottom nav's Menü, so the whole
// bar was 52px spent on a duplicate control.
export function EventCrumb({ className }: { className?: string }) {
  const { lang } = useParams<{ lang: string }>();
  const event = useEventDetailStore((s) => s.event);

  return (
    <Link
      href={`/${lang}/events`}
      className={cn(
        "-ml-1.5 flex h-9 w-fit max-w-full items-center gap-1.5 rounded-lg px-1.5 transition-colors hover:text-brand-light focus-ring lg:hidden",
        className,
      )}
    >
      <ChevronLeft
        className="h-[18px] w-[18px] shrink-0 text-muted-foreground"
        aria-hidden
      />
      {event?.name ? (
        <span className="truncate font-display text-[15px] font-semibold text-foreground">
          {event.name}
        </span>
      ) : (
        <Image
          src="/venuer-logo.png"
          alt="Venuer"
          width={72}
          height={18}
          className="h-[18px] w-auto opacity-70"
        />
      )}
    </Link>
  );
}
